export default __webpack_public_path__ + "static/media/Bandeau 23 HD.d3f95d04.jpg";